import { IEnum, IMDMUnit, IMDMUnitField, IPassportSchemaField } from '@/pages/MDM/mdm.types.ts'
import DropdownInput from 'src/shared/Inputs/DropdownInput'
import { useMemo } from 'react'
import mdmDataTypeOptions from '@/pages/MDM/components/MDMDataTypeDropdown/mdmDataType.options.ts'
import usePrimitives from '@/pages/MDM/hooks/usePrimitives.ts'
import { IDropdownGroupOption } from '@/shared/Inputs/DropdownInput/dropdown.types.ts'
import useUnits from '@/pages/MDM/hooks/useUnits.ts'

interface IProps {
  value: Partial<Pick<IPassportSchemaField, 'typeEnumId' | 'type' | 'typeUnitId'>>
  onChange: (val: Pick<IPassportSchemaField, 'typeEnumId' | 'type' | 'typeUnitId'>) => void
  allowUnit?: boolean
}

const MDMDataTypeDropdown = (props: IProps) => {
  const primitives = usePrimitives()
  const units = useUnits()

  const options = useMemo(() => {
    const primitivesGroup: IDropdownGroupOption = {
      key: 'enums',
      title: 'Примитив',
      children: primitives.map((p) => ({ title: p.name, value: p.id })),
    }
    const unitsGroup: IDropdownGroupOption = {
      key: 'units',
      title: 'Агрегат',
      children: units.map((p) => ({ title: p.name, value: p.id })),
    }

    return props.allowUnit
      ? [...mdmDataTypeOptions, primitivesGroup, unitsGroup]
      : [...mdmDataTypeOptions, primitivesGroup]
  }, [primitives])

  const handleSelect = (value: IMDMUnitField['type'] | IEnum['id'] | IMDMUnit['id'], _, group) => {
    if (group === 'enums') {
      props.onChange({ type: 'ENUM', typeEnumId: +value, typeUnitId: null })
    } else if (group === 'units') {
      props.onChange({ type: 'UNIT', typeEnumId: null, typeUnitId: +value })
    } else {
      props.onChange({ typeEnumId: null, typeUnitId: null, type: value.toString() as IMDMUnitField['type'] })
    }
  }

  const getGroupKey = () => {
    if (props.value.typeEnumId) return 'enums'
    if (props.value.typeUnitId) return 'units'

    return null
  }

  return (
    <DropdownInput
      options={options}
      groupKey={getGroupKey()}
      selectedOption={(props.value.typeEnumId || props.value.typeUnitId || props.value.type) as any}
      title="Выберите тип"
      onSelect={handleSelect}
    />
  )
}

export default MDMDataTypeDropdown
